export function base64ToUnicode (encodedString) {
  const binaryString = atob(encodedString)

  const bytes = Uint8Array.from(binaryString, (m) => m.codePointAt(0))

  return new TextDecoder().decode(bytes)
}
